import React, { useState } from 'react'

function Faqs() {
    
    const [activeIndex, setActiveIndex] = useState(null);
   
    const toggleFAQ = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    const features = [
        {
          title: "When is the deadline to file my taxes?",
          description:
            "The tax filing deadline for individuals in Canada is typically April 30th. If you are self-employed, you have until June 15th, but any balance owing must still be paid by April 30th.",
        },
        {
          title: "What documents do I need to file my taxes?",
          description:
            "Common documents include T4 slips (employment income), T2202 (Tuition Fee), T5 slips (investment income), RRSP contribution receipts, FHSA Contribution, medical expenses, charitable donation receipts, and any other relevant tax documents.",
        },
        {
          title: "Can I file my taxes late?",
          description:
            "Yes, but late filing may result in penalties and interest if you owe taxes. We recommend filing on time to avoid unnecessary charges.",
        },
        {
          title: "How long does it take to process my tax return?",
          description:
            "Once we receive all necessary documents, we typically process and file your return within 2-3 business days.",
        },
        {
          title: "How long does it take to receive my tax refund?",
          description:
            "If you file electronically and have direct deposit set up, you can typically receive your refund within two weeks. Paper filings may take up to eight weeks.",
        },
        {
          title: "What expenses can I deduct as a self-employed individual?",
          description:
            "You can deduct business-related expenses such as office supplies, rent, utilities, vehicle expenses, advertising, and more.",
        },
      ];
  return (
    <div>
         {/* Features */}
        
         <section className="mb-16 bg-white p-8  max-w-6xl mx-auto pt-16 md:pt-20">
         {/* <h2 className="text-3xl md:text-5xl text-center font-semibold text-gray-800 mb-20">
        Frequently Asked Questions
         </h2> */}
         <h1 className="text-2xl font-bold  md:text-5xl xl:text-5xl text-center mb-20 text-slate-900">
         Frequently Asked Questions
      </h1>
         <div>
           {features.map((feature, index) => (
             <div
               key={index}
               className="border-b border-gray-400 p-3 mb-4 "
             >
               <div
                 className="flex justify-between items-center cursor-pointer"
                 onClick={() => toggleFAQ(index)}
               >
                 <h3 className="text-xl md:text-3xl font-semibold text-gray-800 mb-6">
                   {feature.title}
                 </h3>
                 <button
                   className="text-xl md:text-3xl font-bold text-gray-600"
                   aria-label="Toggle FAQ"
                 >
                   {activeIndex === index ? "-" : "+"}
                 </button>
               </div>
               {activeIndex === index && (
                 <p className="text-gray-600 mt-2 text-base md:text-xl">{feature.description}</p>
               )}
             </div>
           ))}
         </div>
       </section>
    </div>
  )
}

export default Faqs